import { humanizeStatus } from '@/lib/format';

const STYLES: Record<string, string> = {
    // Referral states
    CONFIRMED: 'bg-green-100 text-green-700',
    PENDING_REVIEW: 'bg-amber-100 text-amber-700',
    VOIDED: 'bg-red-100 text-red-700',
    // Ambassador states
    ACTIVE: 'bg-green-100 text-green-700',
    INVITED: 'bg-blue-100 text-blue-700',
    SUSPENDED: 'bg-red-100 text-red-700',
    DELETED: 'bg-[#f0f0f0] text-[#888]',
    // Invitation states
    Pending: 'bg-amber-100 text-amber-700',
    Accepted: 'bg-green-100 text-green-700',
    Expired: 'bg-[#f0f0f0] text-[#888]',
    Revoked: 'bg-red-100 text-red-700',
};

export default function StatusBadge({ status }: { status: string }) {
    const style = STYLES[status] ?? 'bg-[#f0f0f0] text-[#888]';
    return (
        <span className={`inline-block whitespace-nowrap rounded-full px-3 py-1 text-[12px] font-semibold ${style}`}>
            {humanizeStatus(status)}
        </span>
    );
}
